<template>
    <div>
        <div class="complaint-content">
            <div class="form-info">
                <el-form :model="feedbackInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                    <div class="form-row">
                        <div class="form-label">
                            <label class="required">反馈类型</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="typeId">
                                <el-select v-model="feedbackInfo.typeId" placeholder="请选择反馈类型">
                                    <el-option v-for="item in types" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-row" style="height: 90px">
                        <div class="form-label">
                            <label class="required">问题描述</label>
                        </div>
                        <div class="form-value width-2x">
                            <el-form-item prop="content">
                                <el-input type="textarea" v-model="feedbackInfo.content"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import merchtComnApi from '../../api/merchtComn'

    export default{
        name: 'swb-feedback-create',
        desc: '意见反馈创建',
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空'));
                } else {
                    callback();
                }
            };
            return {
                feedbackInfo: {
                    typeId: null
                },
                types: [],
                rules: {
                    typeId: [{validator: checkNull, trigger: 'blur'}],
                    content: [{validator: checkNull, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            let self = this;
            self.getFeedbackTypeList();
        },
        methods: {
            getFeedbackTypeList: function () {
                let self = this;
                let postData = {};
                let theLoad = MsgBox.loading();
                merchtComnApi.getFeedbackTypeList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.types = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            //
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.feedbackInfo;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/feedback/FeedbackCreate.vue